import React from 'react';
import { withRouter } from 'inferno-router';
import {
  ScrollView,
  StyleSheet,
  Text,
  View,
} from './components/base_components';

import GameButton from './components/buttons/game_button';
import GameOverlay from './components/overlays/game_overlay';
import MenuButton from './components/buttons/menu_button';
import { GAME_LIST, Game } from './data/games';

const styles = StyleSheet.create({
  gameListScreen: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'transparent',
  },
  scroller: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    flexDirection: 'column',
  },
  scrollInner: {
    alignSelf: 'stretch',
    flexDirection: 'column',
    jusityfContent: 'flex-start',
    alignItems: 'center',
    overflowY: 'scroll',
  },
  gameList: {
    marginTop: '2em',
    marginBottom: '5em',
    width: '25em',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-around',
    alignItems: 'center',
  },
  gameButton: {
    marginTop: '1em',
    marginBottom: '1em',
  },
  menuButton: {
    position: 'absolute',
    top: '1em',
    right: '1em',
    width: '3em',
    height: '3em',
  },
  titleWrapper: {
    marginTop: '4em',
    marginLeft: '2em',
    marginRight: '2em',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
  },
  titleText: {
    alignSelf: 'stretch',
    color: 'white',
    fontSize: '2em',
    textAlign: 'center',
  },
});

type Props = {};
type State = {
  show_game: Game | null;
};

class GameListScreen extends React.PureComponent<Props, State> {
  constructor(props, context) {
    super(props, context);
    const { game_name } = props.match.params;
    let game = null;
    if (game_name) {
      game = GAME_LIST.find(g => g.game_name === game_name);
    }
    this.state = {
      show_game: game || null,
    };
  }
  _onGamePress = game => {
    const url = `/games/${game.game_name}`;
    this.props.history.push(url, { game_push: true });
  };
  _onGameDone = () => {
    if (
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.game_push
    ) {
      this.props.history.goBack();
    } else {
      this.props.history.push('/games');
    }
  };

  render() {
    const { show_game } = this.state;
    let overlay = null;
    if (show_game) {
      overlay = <GameOverlay game={show_game} onDone={this._onGameDone} />;
    }

    const games = GAME_LIST.map(game => {
      return (
        <GameButton
          key={game.game_name}
          style={styles.gameButton}
          game={game}
          onPress={this._onGamePress}
        />
      );
    });

    return (
      <View style={styles.gameListScreen}>
        <ScrollView
          style={styles.scroller}
          contentContainerStyle={styles.scrollInner}
        >
          <View style={styles.titleWrapper}>
            <Text style={styles.titleText}>Dank Meme Presents:</Text>
          </View>
          <View style={styles.gameList}>{games}</View>
        </ScrollView>
        <MenuButton />
        {overlay}
      </View>
    );
  }
}

export default withRouter(GameListScreen);
